import type { IconType } from 'react-icons';
import { FiBook, FiBookOpen, FiDownload, FiFileText, FiGrid, FiPackage, FiSearch, FiUser } from 'react-icons/fi';

const GROUP_ICONS: Record<string, IconType> = {
  Courses: FiBookOpen,
  Categories: FiGrid,
  Instructors: FiUser,
  Articles: FiFileText,
  Resources: FiDownload,
  Bundles: FiPackage,
  Books: FiBook,
};

export function SearchResultIcon({ group, className = 'size-4' }: { group: string; className?: string }) {
  const Icon = GROUP_ICONS[group] ?? FiSearch;
  return <Icon className={className} aria-hidden />;
}
